import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {UserList} from "./UserList";
import {User} from "./User";
import {Switch,Route} from 'react-router-dom';
import routes from '../../utilities/route_constants';

const useStyles = makeStyles(theme => ({
    
}));

export function UserContainer(){

    const classes = useStyles();

    return (
        <Switch>
            <Route exact path={"/users"} component={UserList} />
            <Route path={"/users/:id"} component={User} />
        </Switch>
    )
}